<template>
  <v-dialog scrollable max-width="900px" v-model="showDialog">
    <template v-slot:activator="{ on }">
      <div class="my-2">
        <a v-on="on" @click="cargar"> {{ '(' + persona.edad + ') ' + persona.nombreCompleto }}</a>
      </div>
    </template>

    <v-card v-if="persona">
      <v-card-title>
        <h4>FICHA DIGITAL</h4>
      </v-card-title>
      <v-card-text>

        <input ref="fileSelector" accept="image/*" type="file" class="d-none">
        <div class="d-flex flex-wrap align-center">

          <div style=" max-width: 200px">
            <FotoSocio :cedula="persona.cedula" />
          </div>

          <div class="mt-2" style="max-width: 500px">
            <div>
              <h5 class="mb-2 mt-3">Datos personales</h5>
            </div>
            <div>Nombres: {{ persona.nombreCompleto }} </div>
            <div>Número de Cédula: {{ persona.cedula }} </div>
            <div v-if="persona.fechaNacimiento">Fecha de Nacimiento {{ persona.fechaNacimiento | dateFormat }} ({{
              calculateAge(persona) }} años de edad)</div>

            <div>
              <h5 class="mb-2 mt-3">Contacto</h5>
            </div>
            <div>Teléfono: {{ persona.celular }}</div>
            <div>Localidad: {{ persona.localidad }}</div>
            <div>Dirección: {{ persona.direccion }}</div>

            <div>
              <h5 class="mb-2 mt-3">Datos del socio</h5>
            </div>
            <div>Número IP: {{ persona.ipName }} </div>
            <div>Codigo SGS: {{ persona.codMemSq }} </div>
            <div v-if="persona.fechaIngreso">Fecha de Ingreso: {{ persona.fechaIngreso | dateFormat }} ({{
              calculateAntSoc(persona) }} años de antiguedad)
            </div>
            <div>Tipo de Socio: {{ persona.memType }}</div>
            <div>Contrato: {{ persona.contratoGestion }}</div>
            <div v-if="persona.fechaDefuncion">Fecha de Defunción: {{ persona.fechaDefuncion | dateFormat }}</div>


            <div>
              <h5 class="mb-2 mt-3">Datos del pago</h5>
            </div>
            <div>Forma Cobro: {{ persona.formaCobro }} </div>
            <div>Número de Cuenta: {{ persona.numeroCuentaBancaria }} </div>


          </div>

        </div>

      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="info" @click="showDialog = false">Volver</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import moment from 'moment';
import FotoSocio from "@/components/cumpleanos/FotoSocio.vue";


export default {

  props: ['persona'],

  components: { FotoSocio },
  data() {
    return {
      showDialog: false,
      imageBytes: null,
      loading: false
    }
  },
  mounted() {

  },
  methods: {
    cargar() {

    },
    calculateAge(persona) { // birthday is a date
      const fechaDesde = new Date(persona.fechaNacimiento)
      const fechaHasta = persona.fechaDefuncion ? new Date(persona.fechaDefuncion) : new Date()
      const ageDifMs = fechaHasta - fechaDesde;
      const ageDate = new Date(ageDifMs); // miliseconds from epoch
      return Math.abs(ageDate.getUTCFullYear() - 1970);
    },

    calculateAntSoc(persona) { // birthday is a date
      const fechaDesde = new Date(persona.fechaIngreso)
      const fechaHasta = persona.fechaDefuncion ? new Date(persona.fechaDefuncion) : new Date()
      const ageDifMs = fechaHasta - fechaDesde;
      const ageDate = new Date(ageDifMs); // miliseconds from epoch
      return Math.abs(ageDate.getUTCFullYear() - 1970);
    },
  },
  filters: {
    dateFormat(value) {
      if (value) {
        return moment(String(value)).format("DD/MM/YYYY");
      }
    },
  },
}
</script>

<style></style>